import React, {  useState, useEffect, useRef, useCallback } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import { TailSpin } from "react-loader-spinner";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";

import Add_customer from "../../Components/Admin_components/add_customer.js";
import Delete_customer from "../../Components/Admin_components/delete_customer.js";

import "../../Api/apiUrls";
import { getAdminCustomer } from "../../Api/apiUrls";

// Debounce function to limit rapid firing of events
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function Customer() {
  // Data states
  const [allPayouts, setAllPayouts] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({});
  
  // Loading states
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(1);

  // Modal and selection states
  const [modalAdd_customerIsOpen, setAdd_customerModalIsOpen] =
    useState("");
  const [modalDelete_customerIsOpen, setDelete_customerIsOpen] =
    useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  // Filter and search states
  const [searchQuery, setSearchQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const tableContainerRef = useRef();
  const searchInputRef = useRef();

  const Status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  const [selectedStatus, setSelectedStatus] = useState("All");


  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption.value);
    setPage(1);
    setAllPayouts([]);
  };

  const handleSearchInputChange = (event) => {
    const newValue = event.target.value;
    setSearchQuery(newValue);
    
    if (newValue === "") {
      setSearchTerm("");
      setPage(1);
      setAllPayouts([]);
      fetchPassPayout(1, true);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setSearchTerm(searchQuery);
    setPage(1);
    setAllPayouts([]);
    fetchPassPayout(1, true);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit(e);
    }
  };

  
  const closeAdd_customer = () => {
    setAdd_customerModalIsOpen(false);
  };
  const openAdd_customer = () => {
    setAdd_customerModalIsOpen(true);
  };
  const openDelete_customer = (customerId) => {
    setSelectedCustomerId(customerId);
    closeDelete_customer();
    setDelete_customerIsOpen(true);
  };

  const closeDelete_customer = () => {
    setDelete_customerIsOpen(null);
  };


  const fetchPassPayout = useCallback(async (pageNum = 1, reset = false) => {
    // Don't fetch if we're trying to go beyond total pages
    if (pagination.total_pages && pageNum > pagination.total_pages) {
      setHasMore(false);
      return;
    }
    
    setIsFetching(true);
    try {
      let url = `${getAdminCustomer}?page=${pageNum}&page_size=50`;
      
      if (selectedStatus !== "All") {
        url += `&status=${selectedStatus}`;
      }
      
      if (searchTerm) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }

      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      
      if (!data.data || !data.data.users) {
        throw new Error("Invalid data format from API");
      }
      
      const newUsers = data.data.users;
      
      if (reset || pageNum === 1) {
        setAllPayouts(newUsers);
      } else {
        setAllPayouts(prev => [...prev, ...newUsers]);
      }
      
      setPagination(data.data.pagination || {});
      setTotalItems(data.data.pagination?.total_items || 0);
      
      const currentPage = data.data.pagination?.current_page || 1;
      const totalPages = data.data.pagination?.total_pages || 1;
      setHasMore(currentPage < totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllPayouts([]);
      setTotalItems(0);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  }, [selectedStatus, searchTerm, pagination.total_pages]);

  useEffect(() => {
    fetchPassPayout(page);
  }, [page, fetchPassPayout]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container || isFetching || !hasMore) return;

    const handleScroll = debounce(() => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollHeight - (scrollTop + clientHeight) < 50) {
        setPage(prev => {
          const nextPage = prev + 1;
          // Check if nextPage exceeds total pages
          if (pagination.total_pages && nextPage > pagination.total_pages) {
            return prev;
          }
          return nextPage;
        });
      }
    }, 200);

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [isFetching, hasMore, pagination.total_pages]);


  const formatCreatedAt = (createdAt) => {
    const createdAtDate = new Date(createdAt);
    return createdAtDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const showingCount = allPayouts.length;
  const isFiltered = searchTerm || selectedStatus !== "All";

  return (
    <div>
      <Header />
      {modalAdd_customerIsOpen && (
        <Add_customer onClose={closeAdd_customer} />
      )}
      {modalDelete_customerIsOpen && (
          <Delete_customer
            open={modalDelete_customerIsOpen}
            onClose={() => setDelete_customerIsOpen(false)}
            customer={selectedCustomerId}
          />
        )}

      
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Customer</h1>
        </div>
        <section className="section">
          <div className="card p-2">
          <div class="parent col-md-12 row mt-2">
              <div class="col-md-8">
              <form onSubmit={handleSearchSubmit} className="d-flex">
                  <div className="child mr-2 mb-2">
                    <input
                      ref={searchInputRef}
                      onChange={handleSearchInputChange}
                      value={searchQuery}
                      type="text"
                      className="form-control"
                      placeholder="Search all fields..."
                    />
                  </div>
                  <div className="child mr-2 mb-2">
                    <button 
                      type="submit" 
                      className="btn btn-primary"
                      disabled={isFetching}
                    >
                      {isFetching ? 'Searching...' : 'Search'}
                    </button>
                  </div>
                  <div className="child mr-2 mb-2" style={{ minWidth: "200px" }}>
                  <Select
                    options={Status}
                    placeholder="Status"
                    onChange={handleStatusChange}
                    value={Status.find(option => option.value === selectedStatus)}
                    isDisabled={isFetching}
                  />
                </div>
                </form>
                
              </div>
              <div class="col-md-4" style={{ textAlign: "right" }}>
                <div class="child">
                  <a>
                    {" "}
                    {
                      <button
                        id="btnNewUser"
                        type="button"
                        data-toggle="modal"
                        data-target="#modalAdd"
                        class=" btn-round"
                        onClick={openAdd_customer}
                      >
                        <i class="bi bi-person-add"></i> Add Customer
                      </button>
                    }
                  </a>
                </div>
              </div>
            </div>

            <div className="table-responsive" ref={tableContainerRef} style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {isLoading ? (
                <div className="text-center my-5">
                  <TailSpin color="#0d6efd" width={50} />
                </div>
              ) : allPayouts.length > 0 ? (
                <>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Sr.No</th>
                        <th scope="col">Details</th>
                        <th scope="col">Following Artist</th>
                        <th scope="col">Review</th>
                        <th scope="col">Wishlist</th>
                        <th scope="col">Appointment</th>
                        <th scope="col">Location</th>
                        <th scope="col">Saved</th>

                        <th scope="col">Status</th>
                        <th scope="col">Created On</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allPayouts.map((customer, index) => (
                      <tr key={`${customer.id}-${index}`}>
                        <th scope="row">{index + 1}</th>
  
                        <td>
                          {customer.name || "--"}
                          <br />
                          {customer.mobileNumber || "--"}
                          <br />
                          {customer.email || "--"}
                          <br />
                        </td>
  
                        <td>
                          {customer.following_count || "--"}
                          <br />
                        </td>
  
                        <td>
                          {customer.review_count || "--"}
                          <br />
                        </td>
                        <td>
                          {customer.wishlist_count || "--"}
                          <br />
                        </td>
                        <td>
                          {customer.appointment_count || "--"}
                          <br />
                        </td>
                        <td>
                          {customer.city || "--"}
                          <br />
                        </td>
                        <td>
                          {customer.saved_count || "--"}
                          <br />
                        </td>
                        <td>
                          {customer.status || "--"}
                          <br />
                        </td>
                        <td>{formatCreatedAt(customer.created_at)}</td>
                        <td>
                          <div className="social-links mt-2">
                            &nbsp;
                            <a onClick={() => openDelete_customer(customer.id)}>
                              <i class="bi bi-trash3"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  </table>
                  {isFetching && (
                    <div className="text-center py-3">
                      <TailSpin color="#0d6efd" width={50} />
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center py-4">
                  <h4>No Customer data found</h4>
                  <p>Try adjusting your search or filters</p>
                </div>
              )}
            </div>

            <div className="p-3 bg-dark text-white rounded-bottom">
              Showing {showingCount} of {totalItems} total payouts
              {hasMore && !isFetching && !isFiltered && " - scroll to load more"}
              {hasMore && isFiltered && (
                <button 
                  className="btn btn-sm btn-light ml-2"
                  onClick={() => {
                    const nextPage = page + 1;
                    if (pagination.total_pages && nextPage <= pagination.total_pages) {
                      setPage(nextPage);
                    }
                  }}
                  disabled={isFetching || (pagination.total_pages && page >= pagination.total_pages)}
                >
                  {isFetching ? 'Loading...' : 'Load More'}
                </button>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Customer;